import React, { useState } from "react";
import { Phone, MapPin, Mail } from "lucide-react";
import Legal from "@/components/Legal";
import { useT } from "@/i18n";

const Footer = () => {
  const { t } = useT();
  const [legal, setLegal] = useState({ open: false, kind: "terms" });
  const openLegal = (kind) => setLegal({ open: true, kind });
  const closeLegal = () => setLegal((s) => ({ ...s, open: false }));

  const links = t.footer.links;

  return (
    <footer data-testid="site-footer" className="bg-[#faf7f2] border-t border-black/10 pt-20 pb-10">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://milysuperior.com/wp-content/uploads/2023/10/cropped-cropped-Mily-Superior-Logo-1-119x84.png"
                alt="Mily Superior"
                className="h-12 w-auto"
              />
              <div>
                <div className="font-display text-xl tracking-wide">MILY SUPERIOR</div>
                <div className="text-[10px] tracking-[0.25em] text-zinc-500 uppercase mt-0.5">Construction Materials</div>
              </div>
            </div>
            <p className="text-zinc-600 leading-relaxed max-w-sm">{t.footer.tagline}</p>
          </div>

          <div className="md:col-span-4">
            <div className="overline mb-5">{t.footer.contact}</div>
            <ul className="space-y-3 text-zinc-700">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#ea7a1f] shrink-0" />
                <a href="tel:5145941482" data-testid="footer-call" className="copper-line">514-594-1482</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#ea7a1f] shrink-0" />
                <a href="mailto:info@milysuperior.com" data-testid="footer-email" className="copper-line break-all">info@milysuperior.com</a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#ea7a1f] mt-1 shrink-0" />
                <a
                  href="https://www.google.com/maps/search/?api=1&query=1366+Avenue+De+La+Gare+Mascouche+QC+J7K+2Z2"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-address"
                  className="copper-line leading-snug"
                >
                  1366 Avenue De La Gare<br />Mascouche, QC J7K 2Z2
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <div className="overline mb-5">{t.footer.resources}</div>
            <ul className="space-y-3 text-zinc-700">
              <li><a href="#product" className="copper-line">{links[0]}</a></li>
              <li><a href="#system" className="copper-line">{links[1]}</a></li>
              <li><a href="#resources" data-testid="footer-resources-link" className="copper-line">{links[2]}</a></li>
              <li><a href="#quote" className="copper-line">{links[3]}</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-black/10 pt-8 flex flex-col sm:flex-row justify-between gap-4 text-xs text-zinc-500 tracking-wide">
          <div>© {new Date().getFullYear()} Mily Superior. {t.footer.rights}</div>
          <div className="flex flex-wrap gap-x-6 gap-y-2 items-center">
            <button
              data-testid="footer-terms-link"
              onClick={() => openLegal("terms")}
              className="copper-line hover:text-[#ea7a1f] transition-colors"
            >
              {t.footer.terms}
            </button>
            <button
              data-testid="footer-privacy-link"
              onClick={() => openLegal("privacy")}
              className="copper-line hover:text-[#ea7a1f] transition-colors"
            >
              {t.footer.privacy}
            </button>
            <span>{t.footer.trademark}</span>
          </div>
        </div>
      </div>

      <Legal open={legal.open} kind={legal.kind} onClose={closeLegal} />
    </footer>
  );
};

export default Footer;
